/**
 * 문의·신청 전송. 기본은 FormSubmit.
 * Sheet/Apps Script로 바꾸려면 .env에 REACT_APP_INQUIRY_WEBHOOK_URL 만 설정.
 */
import { assembleContactEmail } from '../components/ObfuscatedEmail';

export async function submitInquiry({
  name,
  email,
  subject,
  message,
  honey = '',
  extra = {},
}) {
  if (honey) {
    return { ok: true, skipped: true };
  }

  const webhook = (process.env.REACT_APP_INQUIRY_WEBHOOK_URL || '').trim();
  const payload = {
    name,
    email,
    _replyto: email,
    _subject: subject,
    message,
    ...extra,
  };

  if (webhook) {
    const res = await fetch(webhook, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        ...payload,
        source: 'miraijuken.net',
      }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      throw new Error(data.message || data.error || `HTTP ${res.status}`);
    }
    return { ok: true, via: 'webhook', data };
  }

  const to = assembleContactEmail();
  const res = await fetch(`https://formsubmit.co/ajax/${encodeURIComponent(to)}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      ...payload,
      _template: 'box',
      _captcha: 'false',
      _honey: honey,
    }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.message || data.error || `HTTP ${res.status}`);
  }
  return { ok: true, via: 'formsubmit', data };
}
